import { RowRouteGroupCompanyDto } from "@/dtos";
import { Company, RouteGroupCompany } from "@/entities";

export const formatRowRouteGroupCompany = (routeGroupCompanies: RouteGroupCompany[], companies: Company[]): RowRouteGroupCompanyDto[] => {
    return routeGroupCompanies.map((r) => {
        const company = companies.find((c) => c.id === r.company_id);
        const row: RowRouteGroupCompanyDto = {
            ...r,
            company_id: r.company_id,
            company: company?.name ?? '',
            route_group: r.route_group,
            is_active: r.is_active,
            active: r.is_active ? 'Activo' : 'Inactivo'
        }
        return row;
    });
}